import {
  SortOrder,
  SortByField,
  buildFieldSortCriterion,
  Sort as SortComponent,
  SortByRelevancy,
} from '@coveo/headless';
import { Select, SelectOption } from '@lmig/lmds-react-select';
import Grid from '@mui/material/Grid';

interface ISortProps {
  sort: React.MutableRefObject<SortComponent>;
  relevanceSortCriterion: React.MutableRefObject<SortByRelevancy>;
  show: boolean;
  queryType: string | undefined;
}

export default function Sort({ sort, relevanceSortCriterion, show, queryType }: ISortProps) {
  const createdDateDescendingSortCriterion: SortByField = buildFieldSortCriterion('created', SortOrder.Descending);
  const createdDateAscendingSortCriterion: SortByField = buildFieldSortCriterion('created', SortOrder.Ascending);
  const updatedDateDescendingSortCriterion: SortByField = buildFieldSortCriterion('updated', SortOrder.Descending);
  const updatedDateAscendingSortCriterion: SortByField = buildFieldSortCriterion('updated', SortOrder.Ascending);
  const newsPublishedDateDescendingSortCriterion: SortByField = buildFieldSortCriterion(
    'lmcpublishdate',
    SortOrder.Descending,
  );
  const newsPublishedDateAscendingSortCriterion: SortByField = buildFieldSortCriterion(
    'lmcpublishdate',
    SortOrder.Ascending,
  );

  function handleChange(event: any) {
    switch (event.target.value) {
      case 'relevance':
        sort.current.sortBy(relevanceSortCriterion.current);
        break;
      case 'createddatedescending':
        sort.current.sortBy(createdDateDescendingSortCriterion);
        break;
      case 'createddateascending':
        sort.current.sortBy(createdDateAscendingSortCriterion);
        break;
      case 'updateddatedescending':
        sort.current.sortBy(updatedDateDescendingSortCriterion);
        break;
      case 'updateddateascending':
        sort.current.sortBy(updatedDateAscendingSortCriterion);
        break;
      case 'newspublisheddatedescending':
        sort.current.sortBy(newsPublishedDateDescendingSortCriterion);
        break;
      case 'newspublisheddateascending':
        sort.current.sortBy(newsPublishedDateAscendingSortCriterion);
        break;
      default:
        break;
    }
  }

  return (
    <>
      {show && (
        <Grid container alignContent="center" alignItems="center">
          <Grid size={{ xs: 3 }}>
            <div className="bold">Sort By: &nbsp;</div>
          </Grid>
          <Grid size={{ xs: 9 }}>
            {queryType?.toLowerCase() !== 'news' ? (
              <Select
                id="search-page-sort"
                labelVisual=""
                defaultValue="relevance"
                onChange={(event: any) => handleChange(event)}
                className="select-no-label"
              >
                <SelectOption value="relevance">Relevance</SelectOption>
                <SelectOption value="updateddatedescending">Publish date descending</SelectOption>
                <SelectOption value="updateddateascending">Publish date ascending</SelectOption>
              </Select>
            ) : (
              <Select
                id="search-page-sort"
                labelVisual=""
                defaultValue="newspublisheddatedescending"
                onChange={(event: any) => handleChange(event)}
                className="select-no-label"
              >
                <SelectOption value="relevance">Relevance</SelectOption>
                <SelectOption value="newspublisheddatedescending">Publish date descending</SelectOption>
                <SelectOption value="newspublisheddateascending">Publish date ascending</SelectOption>
              </Select>
            )}
          </Grid>
        </Grid>
      )}
    </>
  );
}
